<template>
  <v-menu
    v-model="menu"
    offset-x
    min-width="800px"
    :close-on-click="false"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        small
        v-on="on"
      >
        Додати Сервіс
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <v-row dense>
          <v-col xs6>
            <ServiceSelect
              v-model="selected"
              @input="onServiceChange"
            />
          </v-col>
          <v-col xs6>
            <DecimalEditor
              v-model="quantity"
              label="Кількість"
              :error-messages="$v.quantity.$error ? errors.QUANTITY : []"
              :hide-details="false"
              @input="$v.quantity.$touch()"
            />
          </v-col>
        </v-row>
        <v-row
          dense
          class="mt-n4"
        >
          <v-col xs6>
            <DecimalEditor
              v-model="price"
              :disabled="saleOptions === serviceSaleOptions.WITH_VAT.label"
              label="Ціна без ПДВ"
              scale="2"
              hide-details
            />
          </v-col>
          <v-col xs6>
            <DecimalEditor
              v-model="priceWithVAT"
              :disabled="saleOptions === serviceSaleOptions.WITHOUT_VAT.label"
              label="Ціна з ПДВ"
              scale="2"
              hide-details
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col xs6>
            <DatePicker
              v-model="startFrom"
              label="Дата активації"
              default-value
              :filled="false"
            />
          </v-col>
          <v-col xs6>
            <DatePicker
              v-model="payedTo"
              label="Сплачено до"
              default-value
              :filled="false"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col xs6>
            <DecimalEditor
              :value="amount"
              :disabled="true"
              label="Сума без ПДВ"
              scale="2"
              hide-details
            />
          </v-col>
          <v-col xs6>
            <DecimalEditor
              :value="amountWithVAT"
              :disabled="true"
              label="Сума з ПДВ"
              scale="2"
              hide-details
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="saleOptions !== serviceSaleOptions.BOTH_VAT.label"
          :disabled="service === null"
          color="primary"
          text
          @click="ok"
        >
          {{ saleOptions === serviceSaleOptions.WITH_VAT.label ? "З ПДВ" : "Без ПДВ" }}
        </v-btn>
        <v-btn
          v-if="saleOptions === serviceSaleOptions.BOTH_VAT.label"
          :disabled="service === null"
          color="primary"
          text
          @click="ok(false)"
        >
          Без ПДВ
        </v-btn>
        <v-btn
          v-if="saleOptions === serviceSaleOptions.BOTH_VAT.label"
          :disabled="service === null"
          color="primary"
          text
          @click="ok(true)"
        >
          З ПДВ
        </v-btn>
        <v-btn
          text
          @click="cancel"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import ServiceSelect from "@/views/catalogs/services/ServiceSelect.vue";
import DecimalEditor from "@/components/DecimalEditor.vue";
import DatePicker from "@/components/story/DatePicker";
import * as servicesApi from "@/backend/servicesApi.js";
import serviceSaleOptions from "@/helpers/serviceSaleOptions.js";
import { ERRORS } from "@/helpers";
import { minValue } from "vuelidate/lib/validators";

export default {
  components: {
    DecimalEditor,
    ServiceSelect,
    DatePicker,
  },
  data: () => ({
    menu: false,
    service: null,
    price: 0,
    priceWithVAT: 0,
    saleOptions: null,
    startFrom: null,
    payedTo: null,
    selected: null,
    quantity: 1,
  }),

  validations: {
    quantity: {
      minValue: minValue(1),
    },
  },

  computed: {
    servicePeriodMonths() {
      if (
        !(this.service && this.service.recurrence && this.service.recurrence.id)
      ) {
        return 0;
      }
      if (!(this.startFrom && this.payedTo)) {
        return 0;
      }

      const yearStartFrom = new Date(this.startFrom).getFullYear();
      const yearPayedTo = new Date(this.payedTo).getFullYear();
      const monthStartFrom = new Date(this.startFrom).getMonth();
      const monthPayedTo = new Date(this.payedTo).getMonth();

      return (
        (monthPayedTo -
          monthStartFrom +
          1 +
          12 * (yearPayedTo - yearStartFrom)) /
        this.service.recurrence.id
      );
    },
    amount() {
      const period = this.servicePeriodMonths;
      if (!period) {
        return 0;
      }
      return this.price * period * this.quantity;
    },
    amountWithVAT() {
      const period = this.servicePeriodMonths;
      if (!period) {
        return 0;
      }
      return this.priceWithVAT * period * this.quantity;
    },
    serviceSaleOptions(){
      return serviceSaleOptions;
    },
    errors() {
      return {
        QUANTITY: [ERRORS.ONLY_POSITIVE],
      };
    },
  },
  watch: {
    saleOptions: {
      handler(val){
        if (val === null){
          this.saleOptions = this.serviceSaleOptions.BOTH_VAT.label;
        }
      },
      immediate: true,
    },
  },
  methods: {
    async onServiceChange() {
      if (this.selected?.id) {
        this.service = await servicesApi.getService(this.selected.id);
        this.saleOptions = this.service.saleOptions;
        this.price = this.service.amount;
        this.priceWithVAT = this.service.amountWithVAT;
        this.service.id = this.selected.id;
      }
    },
    ok(withVAT) {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.$emit("input", {
        id: this.service.id,
        title: this.service.title,
        amount:
          this.saleOptions === this.serviceSaleOptions.BOTH_VAT.label
            ? withVAT
              ? this.amountWithVAT
              : this.amount
            : this.saleOptions === this.serviceSaleOptions.WITH_VAT.label
              ? this.amountWithVAT
              : this.amount,
        recurrence: this.service.recurrence.id,
        price:
          this.saleOptions === this.serviceSaleOptions.BOTH_VAT.label
            ? withVAT
              ? this.priceWithVAT
              : this.price
            : this.saleOptions === this.serviceSaleOptions.WITH_VAT.label
              ? this.priceWithVAT
              : this.price,
        startFrom: this.startFrom,
        payedTo: this.payedTo,
        type: {
          id: this.service.type.id,
          title: this.service.type.title,
        },
        quantity: this.quantity,
      });
      this.cancel();
    },
    cancel() {
      this.service = null;
      this.price = 0;
      this.priceWithVAT = 0;
      this.saleOptions = this.serviceSaleOptions.BOTH_VAT.label;
      this.menu = false;
      this.startFrom = this.moment().format("YYYY-MM-DD");
      this.payedTo = this.moment().format("YYYY-MM-DD");
      this.selected = null;
      this.quantity = 1;
    },
  },
};

</script>